import { StateField } from '@codemirror/state';
import { Decoration, EditorView } from '@codemirror/view';

const BANNER_TAG_REGEXP = /\[\[(ad:|adtags:|abm).*?\]\]/g;

const createDecorations = (doc) => {
  const decorations = [];
  const text = doc.toString();

  let match = BANNER_TAG_REGEXP.exec(text);

  while (match) {
    const start = match.index;
    const end = start + match[0].length;
    const range = Decoration.mark({ class: 'banner-tag' }).range(start, end);

    decorations.push(range);

    match = BANNER_TAG_REGEXP.exec(text);
  }

  return Decoration.set(decorations);
};

export const bannerStyles = EditorView.baseTheme({
  '.banner-tag': {
    backgroundColor: '#ff3c3c30',
    borderRadius: '20px',
    color: 'var(--color-red-300)',
    padding: '1px 4px 3px'
  },
  '.cm-line .banner-tag::selection': {
    backgroundColor: 'rgba(0,0,0,.15) !important',
    borderRadius: 'var(--border-radius-base)'
  }
});

export const bannerHighlighting = StateField.define({
  create(state) {
    return createDecorations(state.doc);
  },
  update(decorations, tr) {
    if (tr.docChanged) {
      return createDecorations(tr.newDoc);
    }

    return decorations;
  },
  provide: (f) => EditorView.decorations.from(f)
});
